module.exports = __webpack_public_path__ + "static/media/background_1920-5.1d98ff2e.jpg";